export default {
  profiles: 'Grupos de Usuário',
  'profiles.domain.name': 'Nome',
  'profiles.domain.roles': 'Permissões',

  'profiles.create': 'Criar Novo Grupo',
  'profiles.create.notification.success': 'Sucesso',
  'profiles.create.notification.successDescription':
    'Grupo de Usuários criado.',

  'profiles.update': 'Editar Grupo de Usuário',
  'profiles.update.notification.success': 'Sucesso',
  'profiles.update.notification.successDescription':
    'Grupo de Usuário atualizado.',

  'profiles.remove': 'Remover Grupo de Usuário',
  'profiles.remove.alert': 'Você realmente deseja remover o grupo de usuário:',
  'profiles.remove.notification.success': 'Sucesso',
  'profiles.remove.notification.successDescription':
    'Grupo de Usuário removido.',
};
